import api from './api';
import { Passivo } from '../types/passivos';
import { handleError } from '../utils/errorHandler';

export const getPassivos = async (
  pageIndex: number,
  pageSize: number = 100,
  sortBy: any[] = [],
  globalFilter: string = '',
  tipoFilter: string = '',
) => {
  try {
    const sortParam   = sortBy.length > 0 ? `&ordering=${sortBy.map(s => (s.desc ? '-' : '') + s.id).join(',')}` : '';
    const searchParam = globalFilter ? `&search=${encodeURIComponent(globalFilter)}` : '';
    const tipoParam   = tipoFilter   ? `&tipo=${tipoFilter}`                          : '';

    const response = await api.get<{ results: Passivo[]; count: number }>(
      `/ativos/passivo/?page=${pageIndex + 1}&page_size=${pageSize}${sortParam}${searchParam}${tipoParam}`
    );

    return {
      results: response.data.results,
      totalPages: Math.ceil(response.data.count / pageSize),
    };
  } catch (error) {
    handleError(error, 'ao buscar passivos');
    throw error;
  }
};

export const updatePassivo = async (id: number, data: any) => {
  try {
    const response = await api.patch(`/ativos/passivo/${id}/`, data);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar passivo');
    throw error;
  }
};
